module.exports = __webpack_public_path__ + "86259824aaa19eb68cdd4d28c9f129d0.svg";